import { render, staticRenderFns } from "./imgH.vue?vue&type=template&id=36aa120f"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36aa120f')) {
      api.createRecord('36aa120f', component.options)
    } else {
      api.reload('36aa120f', component.options)
    }
    module.hot.accept("./imgH.vue?vue&type=template&id=36aa120f", function () {
      api.rerender('36aa120f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgH.vue"
export default component.exports